"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAttribute = void 0;
const FileAspectRatio_1 = require("./FileAspectRatio");
const FilePlaybackTime_1 = require("./FilePlaybackTime");
const FileVolume_1 = require("./FileVolume");
class FileAttribute {
    constructor({ aspectRatio, playbackTime, volume, }) {
        this.toJSON = () => ({
            aspectRatio: this.aspectRatio && this.aspectRatio.toJSON(),
            playbackTime: this.playbackTime && this.playbackTime.toJSON(),
            volume: this.volume && this.volume.toJSON(),
        });
        this.aspectRatio = aspectRatio;
        this.playbackTime = playbackTime;
        this.volume = volume;
    }
}
exports.FileAttribute = FileAttribute;
FileAttribute.fromJSON = (json) => {
    const { aspectRatio, playbackTime, volume } = Object.assign({}, json);
    const _aspectRatio = aspectRatio ? FileAspectRatio_1.default.fromJSON(aspectRatio) : undefined;
    const _playbackTime = playbackTime ? FilePlaybackTime_1.default.fromJSON(playbackTime) : undefined;
    const _volume = volume ? FileVolume_1.default.fromJSON(volume) : undefined;
    return new FileAttribute({
        aspectRatio: _aspectRatio,
        playbackTime: _playbackTime,
        volume: _volume,
    });
};
exports.default = FileAttribute;
